import { productionSitesSlice, callTypes } from "./ProductionSitesSlice";
import { getProductionSites, upsertProductionSite, getProductionSite } from '../api/ProductionSitesApi';
import { createDetailedAlert, DetailedAlert } from "../../utils/DetailedAlert";
import { ProductionSite } from "../models/ProductionSitesModel";

const { actions: sliceActions } = productionSitesSlice;

export const dismissAlert = () =>
    async (dispatch: (arg0: any) => void) => {
        dispatch(sliceActions.dismissAlert());
    };

export const fetchProductionSites = () =>
    async (dispatch: (arg0: any) => void) => {
        dispatch(sliceActions.startCall({ callType: callTypes.get }));
        return getProductionSites()
            .then(response => {
                const productionSites = response
                dispatch(sliceActions.productionSitesFetched(productionSites));
            })
            .catch(err => {
                const alert = createDetailedAlert(err, "Failure on GET for Production Sites")
                dispatch(sliceActions.catchError({ alert, callType: callTypes.get }));
            });
    };

export const fetchProductionSite = (code: string) =>
    async (dispatch: (arg0: any) => void) => {
        dispatch(sliceActions.startCall({ callType: callTypes.get }));
        return getProductionSite(code)
            .then(response => {
                if (response.isVisible) {
                    throw new Error("Site is already visible");
                }
                return response;
            })
            .catch(err => {
                const alert = createDetailedAlert(err, "Failure fetching invisible Production Site")
                dispatch(sliceActions.catchError({ alert, callType: callTypes.get }));
                throw err;
            });
    };

export const saveProductionSite = (productionSite: ProductionSite) =>
    async (dispatch: (arg0: any) => void) => {
        dispatch(sliceActions.startCall({ callType: callTypes.put }));
        return upsertProductionSite(productionSite)
            .then(() => {
                dispatch(sliceActions.endCall({ callType: callTypes.put }));
                dispatch(fetchProductionSites())
            })
            .catch(err => {
                const alert = createDetailedAlert(err, "Failure on PUT for Production Site")
                dispatch(sliceActions.catchError({ alert, callType: callTypes.get }));
            });
    };
    
export const loadImportedProductionSite = (file: File) =>
    async (dispatch: (arg0: any) => void) => {
        const text = await file.text()
        try {
            const productionSite = JSON.parse(text) as ProductionSite
            dispatch(sliceActions.importedProductionSiteLoaded(productionSite));
        } catch (error: any) {
            const alert = {
                message: "An error occurred parsing the file",
                apiMessage: error.message,
                data: error.stack
            } as DetailedAlert
            dispatch(sliceActions.catchError({ alert, callType: callTypes.file }));
        }
    };
    
export const importProductionSite = (file: File) =>
    async (dispatch: (arg0: any) => void) => {
        const text = await file.text()
        try {
            const productionSite = JSON.parse(text) as ProductionSite
            dispatch(saveProductionSite(productionSite));
        } catch (error: any) {
            const alert = {
                message: "An error occurred parsing the file",
                apiMessage: error.message,
                data: error.stack
            } as DetailedAlert
            dispatch(sliceActions.catchError({ alert, callType: callTypes.file }));
        }
    };
    
export const resetImportProductionSite = () =>
    async (dispatch: (arg0: any) => void) => {
        dispatch(sliceActions.resetImportProductionSite(null));
    };
